import { App } from 'vue'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  install(app: App<Element>): any {
    app.use(VueEasyLightbox)
  }
}
